import styled from "styled-components";

export const Backdrop = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(20, 26, 38, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

export const Card = styled.div`
    background: #FFFFFF;
    border-radius: 14px;
    padding: 22px 22px 18px;
    width: 100%;
    max-width: 380px;
    box-shadow: 0 12px 40px rgba(20, 26, 38, 0.22);
    font-family: Mulish;
`;

export const Title = styled.h3`
    margin: 0 0 8px;
    font-size: 1.05rem;
    font-weight: 800;
    color: #2B3240;
`;

export const Message = styled.p`
    margin: 0 0 20px;
    font-size: 0.9rem;
    color: #6B7280;
    line-height: 1.4;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

export const CancelBtn = styled.button`
    border: none;
    background: #EEF1F6;
    color: #384250;
    font-family: Mulish;
    font-size: 0.85rem;
    font-weight: 700;
    padding: 9px 18px;
    border-radius: 8px;
    cursor: pointer;
`;

export const ConfirmBtn = styled.button`
    border: none;
    background: ${(p) => (p.$danger ? "#EF4444" : "#2F80ED")};
    color: #FFFFFF;
    font-family: Mulish;
    font-size: 0.85rem;
    font-weight: 700;
    padding: 9px 18px;
    border-radius: 8px;
    cursor: pointer;
`;
